import React, { useEffect, useMemo, useRef } from 'react'
import { Button, Form, Input, message, Radio, Select } from 'antd'
import { SAlert, SGeneralForms, SSegmentedTabs } from 'shj-components'
import { breakManageUpdateById, priceItemSave, priceItemUpdateById } from '@/services/product.ts'
import { isEmpty } from 'lodash-es'
import { InfoCircleTwoTone } from '@ant-design/icons'

const AddOrEdit = props => {
  const { editRef } = props
  const ref = useRef()

  const onFormRef = () => {
    const { onFormRef } = ref.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    onFormRef()?.resetFields()
    if (!isEmpty(props.record)) {
      onFormRef()?.setFieldsValue({
        ...props.record,
      })
    }
  }, [props.record])

  const onFinish = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        props.setLoading?.(true)
        breakManageUpdateById({
          data: {
            ...values,
          },
        })
          .then((res: any) => {
            message.success(res.message || '操作成功')
            props.onCancel?.()
            props.fn?.()
          })
          .finally(() => props.setLoading(false))
      })
  }
  if (editRef) editRef.onFinish = onFinish

  return (
    <>
      <p></p>
      <SGeneralForms
        ref={ref}
        layout={'vertical'}
        initialValues={{ showFlag: true, editFlag: false }}
        configs={[
          {
            formItem: [
              {
                label: '',
                spanCol: 24,
                name: 'id',
                children: (
                  <>
                    <p >
                      {/* <InfoCircleTwoTone style={{ marginRight: '5px' }} />
                      说明：违约金=订单工程总造价*违约金比例，最高比例默认不超过10%。退单时，填写比例大于最低比例，可发起；填写比例小于最低比例，若公司违约金率非空，则需继续判断加上当笔退单，公司违约金率是否低于设置比例，低于设置比例不可发起，高于可发起。
                      特殊：开启异常退单后，可不限制违约金。 */}
                      <SAlert type='info'>
                      说明：违约金=订单工程总造价*违约金比例，最高比例默认不超过10%。退单时，填写比例大于最低比例，可发起；填写比例小于最低比例，若公司违约金率非空，则需继续判断加上当笔退单，公司违约金率是否低于设置比例，低于设置比例不可发起，高于可发起。
                      特殊：开启异常退单后，可不限制违约金。
                      </SAlert>
                    </p>
                  </>
                ),
              },
              { label: 'id', name: 'id', hidden: true },
              { label: 'bizTag', name: 'bizTag', hidden: true },
              { label: 'itemName', name: 'itemName', hidden: true },
              {
                spanCol: 24,
                label: '违约金最低比例（%）',
                type: 'inputNumber',
                name: 'minRatio',
                comConfig: {
                  min: 0,
                  max: 10,
                  precision: 2,
                  placeholder: '请输入0~10的数',
                },
              },
              {
                name: 'orgBreakRatio',
                label: '公司违约金率（%）',
                type: 'inputNumber',
                spanCol: 24,
                comConfig: {
                  min: 0,
                  max: 10,
                  placeholder: '请输入0~10的数',
                  precision: 2,
                },
              },
            ],
          },
        ]}
      />
    </>
  )
}

export default AddOrEdit
